import { useLoginVerifyQuery } from '../../__generated__/chirp/com/hubspot/portals/platform/app/rpc/AccessRpc.hooks';
import { getPortalAccountId, getPortalInstanceId } from '../utils/metadata';
import { usePortalsPlatformObjectId } from '../context/PortalsPlatformObjectIdContext';

export function useLoginVerify(options?: { objectId?: number }) {
  const accountId = getPortalAccountId();
  const portalInstanceId = getPortalInstanceId();
  const contextObjectId = usePortalsPlatformObjectId();
  const objectId = options?.objectId ?? contextObjectId;

  return useLoginVerifyQuery({
    variables: {
      accountId,
      portalInstanceId,
      objectId,
      tolerateInstanceAccessDenied: true,
    },
  });
}
